module.exports = __webpack_public_path__ + "static/media/woman2.b136d37d.jpg";